import { take } from 'ramda';

import { MAX_ROWS_COUNT } from '../config';

export const getShortedList = <T>(listData: T[]): T[] =>
  take(MAX_ROWS_COUNT, listData);
